function bindSizeToPlaylistTray() {
    const videoHeight = jQuery("#youtube-video-container").css("padding-top");
    jQuery("#videos-container-playlist").height(videoHeight);
}

jQuery( window ).resize(function() {
    bindSizeToPlaylistTray();
});

bindSizeToPlaylistTray();